export default __webpack_public_path__ + "static/media/report.6a97bcb9.svg";